import React from "react";

interface RecaptchaBadgeProps {
  show?: boolean;
}

/**
 * Badge customizado do reCAPTCHA que pode ser controlado
 * Aparece apenas quando necessário (login/register)
 */
export const RecaptchaBadge: React.FC<RecaptchaBadgeProps> = ({ show = true }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "16px",
        right: "16px",
        backgroundColor: "#f9f9f9",
        border: "1px solid #d3d3d3",
        borderRadius: "3px",
        padding: "8px 12px",
        fontSize: "12px",
        fontFamily: "Helvetica, Arial, sans-serif",
        color: "#555",
        zIndex: 1000,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: "#1976d2",
          borderRadius: "2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
        }}
      >
        r
      </div>
      <div>
        <div style={{ fontSize: "10px", color: "#999" }}>Protegido por reCAPTCHA</div>
        <div style={{ fontSize: "9px", color: "#999" }}>
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "none" }}
          >
            Privacidade
          </a>
          {" - "}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "none" }}
          >
            Termos
          </a>
        </div>
      </div>
    </div>
  );
};

export default RecaptchaBadge;
